import React, { memo } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { TIconName } from '../../../types'
import IconForOption from '../IconForOption'

const useOptionIconStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    paddingRight: theme.spacing(1),
  },
}))

interface IOptionIconProps {
  /**
   * @example 'PlusIcon'
   */
  iconName: TIconName
}

export const OptionIcon = memo<IOptionIconProps>(({ iconName }) => {
  const classes = useOptionIconStyles()
  return (
    <div className={classes.root}>
      <IconForOption iconName={iconName} />
    </div>
  )
})
